import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const Subtitle = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.textLight};
  margin: 4px 0 0 0;

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;
  margin-top: 16px;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartCardTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricStrip = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;

  @media print {
    display: flex !important;
    gap: 12px !important;
    margin-top: 12px !important;
  }
`

export const MetricBox = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.backgroundWarm};
  border-radius: ${vimovaTheme.borderRadius.small};
  padding: 10px 12px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border-radius: ${vimovaTheme.borderRadius.small} !important;
    padding: 10px 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricBoxLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricBoxValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 2px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricBoxSuffix = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: ${vimovaTheme.fontWeights.normal};
  font-size: 10px;
  color: ${vimovaTheme.colors.textMuted};
  margin-left: 4px;

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TrendBadge = styled.span`
  display: inline-block;
  padding: 4px 14px;
  border-radius: 10px;
  background: ${vimovaTheme.colors.green}26;
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.greenDark};
  margin-top: 6px;

  @media print {
    padding: 4px 14px !important;
    border-radius: 10px !important;
    background: ${vimovaTheme.colors.green}26 !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartArea = styled.div`
  margin-top: 12px;

  @media print {
    margin-top: 12px !important;
  }
`

export const LegendRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  margin-top: 8px;
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textLight};

  @media print {
    display: flex !important;
    gap: 20px !important;
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
  }
`

export const LegendLine = styled.div<{ $color: string; $dashed?: boolean }>`
  width: 12px;
  height: 3px;
  border-radius: 1.5px;
  background: ${({ $dashed }) => ($dashed ? 'transparent' : 'currentColor')};
  border-top: ${({ $dashed, $color }) =>
    $dashed ? `1.5px dashed ${$color}` : 'none'};
  color: ${({ $color }) => $color};

  @media print {
    background: ${({ $dashed }) =>
      $dashed ? 'transparent' : 'currentColor'} !important;
    border-top: ${({ $dashed, $color }) =>
      $dashed ? `1.5px dashed ${$color}` : 'none'} !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
